import React from 'react'
import './Dots.scss'

function Dots() {
  return (
    <div className="dots">
      <div className="dots__second"></div>
    </div>
  )
}

export default Dots
